import { render, staticRenderFns } from "./mall_unusual.vue?vue&type=template&id=c92d0dbe&scoped=true&"
import script from "./mall_unusual.vue?vue&type=script&lang=js&"
export * from "./mall_unusual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92d0dbe",
  null
  
)

export default component.exports